import React from "react";
import {FieldSection} from "../../../../../../collection/tile/edit/left-panel/tabs/fields-tab/chart-types/common/field-section/field-section";
import {FieldInfoProvider} from "../../../../../../collection/tile/edit/left-panel/tabs/tile-tab/chart-types/common/field-info-provider/field-info-provider";
import {LpColorLine} from "../../../../../../common/left-panel/lp-color-line";
import {ffToColorPickerLine} from "../../../../../../../../../common/form/ff-to-color-picker-line";
import {NumberInput} from "../../../../../../../../../common/form/number-input/number-input";
import {ffToNumberInput} from "../../../../../../../../../common/form/ff-to-number-input";

export const ContainerTileTabTheme = ({form}) => {
    return (
        <>
            {FieldSection({
                header: FieldInfoProvider({
                    field: <div className="text">DEFAULT</div>,
                    noCollapsible: true,
                }),
                content: (
                    <>
                        {LpColorLine({
                            label: "Background color",
                            ...ffToColorPickerLine(form.field(["general", "tile", "containerTiles", "tabStyle", "backgroundColorRGB"])),
                        })}

                        {LpColorLine({
                            label: "Text color",
                            ...ffToColorPickerLine(form.field(["general", "tile", "containerTiles", "tabStyle", "fontColorRGB"])),
                        })}

                        {LpColorLine({
                            label: "Border color",
                            ...ffToColorPickerLine(form.field(["general", "tile", "containerTiles", "tabStyle", "borderColorRGB"])),
                        })}

                        {NumberInput({
                            label: "Bottom Border Thickness",
                            unit: "px",
                            ...ffToNumberInput(form.field(["general", "tile", "containerTiles", "tabStyle", "bottomBorderHeight"])),
                            showZero: true,
                        })}
                    </>
                ),
            })}

            {FieldSection({
                header: FieldInfoProvider({
                    field: <div className="text">HOVER</div>,
                    noCollapsible: true,
                }),
                content: (
                    <>
                        {LpColorLine({
                            label: "Background color",
                            ...ffToColorPickerLine(form.field(["general", "tile", "containerTiles", "tabStyle", "hoverBackgroundColorRGB"])),
                        })}

                        {LpColorLine({
                            label: "Text color",
                            ...ffToColorPickerLine(form.field(["general", "tile", "containerTiles", "tabStyle", "hoverFontColorRGB"])),
                        })}

                        {LpColorLine({
                            label: "Border color",
                            ...ffToColorPickerLine(form.field(["general", "tile", "containerTiles", "tabStyle", "hoverBorderColorRGB"])),
                        })}
                    </>
                ),
            })}

            {FieldSection({
                header: FieldInfoProvider({
                    field: <div className="text">ACTIVE</div>,
                    noCollapsible: true,
                }),
                content: (
                    <>
                        {LpColorLine({
                            label: "Background color",
                            ...ffToColorPickerLine(form.field(["general", "tile", "containerTiles", "tabStyle", "activeBackgroundColorRGB"])),
                        })}

                        {LpColorLine({
                            label: "Text color",
                            ...ffToColorPickerLine(form.field(["general", "tile", "containerTiles", "tabStyle", "activeFontColorRGB"])),
                        })}

                        {LpColorLine({
                            label: "Border color",
                            ...ffToColorPickerLine(form.field(["general", "tile", "containerTiles", "tabStyle", "activeBorderColorRGB"])),
                        })}
                    </>
                ),
            })}
        </>
    );
};
